import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Sparkles } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import { useIsRachelAvailable } from '../../rachel/hooks/useIsRachelAvailable';
import { useTranslation } from '../../translation/TranslationContext';
import useAskRachel from '../hooks/useAskRachel';
import { searchBarIconButtonSx } from './SearchBar/searchBar.styles';

interface AskRachelButtonProps {
  term: string;
  activeEntityLabel: string;
  onClose: () => void;
}

const AskRachelButtonInner = ({ term, activeEntityLabel, onClose }: AskRachelButtonProps) => {
  const { translate } = useTranslation();
  const { canAsk, ask } = useAskRachel({ term, activeEntityLabel, onClose });

  if (!canAsk) {
    return null;
  }

  const trimmedTerm = term.trim();
  const label = trimmedTerm
    ? translate(LangEnum.GLOBAL_SEARCH_ASK_RACHEL_ABOUT, { term: trimmedTerm })
    : translate(LangEnum.GLOBAL_SEARCH_ASK_RACHEL);

  return (
    <Tooltip TooltipContent={label} tabIndex={-1}>
      <IconButton
        icon={Sparkles}
        ariaLabel={label}
        testId="global-search-ask-rachel"
        sx={searchBarIconButtonSx}
        onClick={ask}
      />
    </Tooltip>
  );
};

const AskRachelButton = (props: AskRachelButtonProps) => {
  const isRachelAvailable = useIsRachelAvailable();

  if (!isRachelAvailable) {
    return null;
  }

  return <AskRachelButtonInner {...props} />;
};

export default AskRachelButton;
